import { render, staticRenderFns } from "./question-matrix-element.vue?vue&type=template&id=06875e0b&scoped=true&"
import script from "./question-matrix-element.vue?vue&type=script&lang=js&"
export * from "./question-matrix-element.vue?vue&type=script&lang=js&"
import style0 from "./question-matrix-element.vue?vue&type=style&index=0&id=06875e0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06875e0b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VTooltip})
